import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { useEffect, useRef, useState, useMemo } from 'react';
import legendWaldzustandBiomasseImage from '../../Images/legendeVitalitaet.png';
import legendWaldzustandWasserbilanzImage from '../../Images/legendWaldzustandWasserbilanz.png';
import legendBaumartenImage from '../../Images/legendBaumarten.png';
import legendFireImage from '../../Images/legende_feuer.png';
import legendSchadflaechenImage from '../../Images/legendeSchadflaechen.png';


export default function LegendSimple(props: any) {

    let subDrawerAlreadyOpened = useRef(false)
    const useDidMountEffect = (func: any, deps: any) => {
        // Prevents re-render on inital load
        const didMount = useRef(false);
        useEffect(() => {
            if (didMount.current) func();
            else didMount.current = true;
        }, deps);
    }

    // Bundesland change
    useDidMountEffect(() => {
        subDrawerAlreadyOpened.current = true;
        // setSubDrawerAlreadyOpened(true)
    }, [props.leftSubDrawerOpen])


    var legendImage = null;
    switch (props.activeLayer) {
        case "laubwaldWasserTrend":
            legendImage = legendWaldzustandWasserbilanzImage;
            break;
        case "baumarten":
            legendImage = legendBaumartenImage;
            break;

        case "schaden":
            legendImage = legendSchadflaechenImage;
            break;
        case "fire":
            legendImage = legendFireImage;
            break;
        default:
            legendImage = legendWaldzustandBiomasseImage;
            break;
    }

    const legendContent = (

        <Box
            component="img"
            sx={{
                // m: 1,
                // width: "70vw",
                p: 1,
                width: "100%",


            }}
            src={legendImage}
        />

    )

    return (
        <>
            {props.mobile ?
                <LegendMobile
                    {...props}>
                    {legendContent}
                </LegendMobile>
                :
                <LegendDesktop
                    {...props}>
                    {legendContent}
                </LegendDesktop>
            }

        </>


    )

}

function LegendDesktop(props: any) {
    return (
        <Box
            sx={{
                position: 'absolute',
                display: 'flex',
                zIndex: 1000,
                m: 2,
                left: "50%",
                ...(props.activeLayer === 'baumarten' ? {

                    ml: "15px", // (drawerWidth/2)- (width/2)  
                    width: "320px"

                } :
                    {
                        ml: "-55px", //(drawerWidth/2)- (width/2)
                        width: "460px"
                    }
                ),
            }}
        >
            <Paper elevation={3}>
                {props.children}
            </Paper>
        </Box >
    );
}

function LegendMobile(props: any) {
    const handleLegendClick = () => {
        props.setLeftSubDrawerOpen(!props.leftSubDrawerOpen)
        // props.setLeftSubDrawerType("BAUMARTEN")
    }
    return (
        <Box
            onClick={() => handleLegendClick()}
            sx={{
                position: 'relative',
                zIndex: 1000,
                // bottom: 100,
                ...(props.activeLayer === 'baumarten' ? {

                    width: "100%"

                } :
                    {
                        width: "100%"
                    }
                ),
            }}
        >
            <Paper elevation={3} square={true}>
                {props.children}
            </Paper>
        </Box >
    );
}